import { Choices } from "@saleor/components/SingleSelectField";
import { ChangeOrderStatusEnum } from "@saleor/graphql";

export enum FIELD_TYPE {
  SINGLE_INPUT = "SINGLE_INPUT",
  SINGLE_SELECT = "SINGLE_SELECT",
  SUGGESTION_INPUT = "SUGGESTION_INPUT",
  RADIO_GROUP = "RADIO_GROUP",
  DATEPICKER = "DATEPICKER",
  EMPTY_DIV = "EMPTY_DIV",
  MULTIPLE_SELECT = "MULTIPLE_SELECT",
  SINGLE_DATE = "SINGLE_DATE",
  MULTIPLE_SUGGESTION_INPUT = "MULTIPLE_SUGGESTION_INPUT",
  NUMBER_INPUT = "NUMBER_INPUT"
}
export interface FORM_DATA {
  title: string;
  name: string;
  type: string;
  placeholder?: string;
  options?: Choices;
  maxLength?: number;
  defaultValue?: string;
  required?: boolean;
}

export const orderTypeChoices = [
  { label: "All", value: ChangeOrderStatusEnum.ALL },
  { label: "Complete", value: ChangeOrderStatusEnum.COMPLETE },
  { label: "Open / Being Process", value: ChangeOrderStatusEnum.OPEN }
];

export interface SubmitFilterDataType {
  piNo?: string;
  eoNo?: string;
  poNo?: string;
  statusSap?: ChangeOrderStatusEnum;
  status?: any[];
  bu?: string;
  company?: string;
  soldTo?: string;
  shipTo?: string;
  dateSelectionType?: DateSelectionType;
  createDate?: {
    gte: string;
    lte: string;
  };
  lastUpdate?: {
    gte: string;
    lte: string;
  };
  sourceOfApp?: string;
}

export enum DateSelectionType {
  CREATE_DATE = "CREATE_DATE",
  LAST_UPDATE = "LAST_UPDATE"
}
